import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';

export const useLenderSaveFpgAssets = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.lenderSaveFpgAssets(payload);
      const { status, data } = response;

      if (status === 200) {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.fundraising.lender_fr_status_by_company_id],
        });
        return data;
      }

      data?.message && Notify.error({ text: data?.message });
    },
  });
};
